import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const CardItem = ({
  text, align, textColor, isCollectionTitle, className
}) => (
  <Box
    data-testid="item-box"
    sx={{
      display: 'flex',
      padding: '0.5rem',
      borderRadius: '1rem',
      alignItems: 'center'
    }}
    className={className}
  >
    <Text
      sx={{ width: '100%' }}
      align={align}
      size={isCollectionTitle ? 'md' : 'sm'}
      bold
      color={textColor}
    >
      {text}
    </Text>
  </Box>
);

export const StyledCardItem = superstyled({
  name: 'StyledCardItem',
  tag: CardItem,
  propsNeeded: ['isLastItem', 'bgColor'],
  styles: ({ isLastItem, bgColor }) => ({
    marginBottom: !isLastItem ? '0.5rem' : undefined,
    backgroundColor: bgColor
  })
});

export const TallStyledCardItem = superstyled({
  tag: StyledCardItem,
  styles: {
    minHeight: '100%'
  }
});

CardItem.propTypes = {
  text: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center']),
  textColor: PropTypes.oneOf(['focus00', 'focus90']),
  isCollectionTitle: PropTypes.bool
};

CardItem.defaultProps = {
  text: 'Item',
  align: 'left',
  textColor: 'focus00',
  isCollectionTitle: false
};
